<template>
  <div id="dashboard">

  </div>
</template>

<script>
import embed from 'vega-embed';

export default {
  name: "ArrayBeam",
  props: ['date_str'],
  async mounted() {
    await this.draw()
  },
  watch: {
    date_str: function (val) {
      if (val) this.draw()
    }
  },
  methods: {
    async draw() {
      await embed('#dashboard', this.specification, {actions: false});
    }
  },
  data() {
    return {}
  },
  computed: {
    specification() {
      return {
        "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
        "description": "A scatterplot showing the pointings of the observation",
        "data": {'url': this.url, 'name': 'pointings'},
        "mark": "point",
        "params": [{
          name: "highlight_point",
          select: {type: "point", on: "mouseover", nearest: true}
        }],
        "encoding": {
          "x": {"field": "x", "type": "quantitative", 'title': 'DX'},
          "y": {"field": "y", "type": "quantitative", 'title': 'DY'},
          "color": {"field": "time", type: "nominal"},
          "size": {
            condition: {param: "highlight_point", value: 50},
            value: 20
          }
        },
        "transform": [
          {'filter': 'abs(datum.x)<3100'}
        ]
      }
    },
    url() {
      let url = 'https://spaceweather.astron.nl/api/beam_position/'
      if (this.date_str != null) {
        url += '?date=' + this.date_str;
      }
      console.log(url)
      return url
    }
  }
}
</script>

<style scoped>

</style>